/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MediaFilePartialUpdate
 */
export interface MediaFilePartialUpdate {
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaFilePartialUpdate
     */
    info?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaFilePartialUpdate
     */
    customFields?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {number}
     * @memberof MediaFilePartialUpdate
     */
    totalFiles?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFilePartialUpdate
     */
    needsRescan?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaFilePartialUpdate
     */
    bookmarkedBy?: Array<number>;
}

export function MediaFilePartialUpdateFromJSON(json: any): MediaFilePartialUpdate {
    return MediaFilePartialUpdateFromJSONTyped(json, false);
}

export function MediaFilePartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaFilePartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'info': !exists(json, 'info') ? undefined : json['info'],
        'customFields': !exists(json, 'custom_fields') ? undefined : json['custom_fields'],
        'totalFiles': !exists(json, 'total_files') ? undefined : json['total_files'],
        'needsRescan': !exists(json, 'needs_rescan') ? undefined : json['needs_rescan'],
        'bookmarkedBy': !exists(json, 'bookmarked_by') ? undefined : json['bookmarked_by'],
    };
}

export function MediaFilePartialUpdateToJSON(value?: MediaFilePartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'info': value.info,
        'custom_fields': value.customFields,
        'total_files': value.totalFiles,
        'needs_rescan': value.needsRescan,
        'bookmarked_by': value.bookmarkedBy,
    };
}


